<template>
    <el-container class="pay-container">
      <el-header>
        <el-button style="margin-top: 20px" icon="el-icon-arrow-left" plain @click="back">返回</el-button>
      </el-header>
      <el-main class="pay-main">
        <div>
          <span class="sign">续期时长</span>
          <el-radio-group v-model="payForm.months">
            <el-radio-button label="一天"></el-radio-button>
            <el-radio-button label="一个月"></el-radio-button>
            <el-radio-button label="三个月"></el-radio-button>
            <el-radio-button label="一年"></el-radio-button>
          </el-radio-group>
        </div>
        <div style="margin-top: 20px;">
          <span class="sign">支付方式</span>
          <el-radio-group v-model="payForm.payType">
            <el-radio-button label="支付宝"></el-radio-button>
            <!-- <el-radio-button label="微信"></el-radio-button> -->
          </el-radio-group>
        </div>
        <div style="margin-top: 20px;" v-if="payForm.months==='一天'">
          <span class="sign">支付金额</span><span style="color: red;">9元</span>
        </div>
        <div style="margin-top: 20px;" v-if="payForm.months==='一个月'">
          <span class="sign">支付金额</span><span style="color: red;">15元</span>
        </div>
        <div style="margin-top: 20px;" v-if="payForm.months==='三个月'">
          <span class="sign">支付金额</span><span style="color: red;">35元</span>
        </div>
        <div style="margin-top: 20px;" v-if="payForm.months==='一年'">
          <span class="sign">支付金额</span><span style="color: red;">68元（本月活动价）</span>
        </div>
        <el-button style="margin-top: 20px;" type="primary" @click="payConfirm">确认支付</el-button>
        <el-dialog title= "扫码支付"
          :visible.sync="centerDialogVisible" center>
          <div style="margin: auto; display:block; width: 100px; height: 100px"><qriously :value="qrcodeUrl" :size="100" /></div>
          <div style="margin: auto; display:block; margin-top: 20px; text-align: center;">手机不方便扫码?</div>
          <div style="margin: auto; display:block; margin-top: 5px; text-align: center;">保存二维码-打开{{ payForm.payType }}-扫一扫-选择相册</div>
          <div style="margin: auto; display:block; margin-top: 5px; text-align: center;">遇到问题请联系微信crystalgogo</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="payFinish">支付完成</el-button>
          </span>
        </el-dialog>
      </el-main>
    </el-container>
</template>

<script>
export default {
  name: 'Pay',
  data () {
    return {
      payForm: {
        months: '一个月',
        payType: '支付宝'
      },
      weixin: 'crystalgogo',
      centerDialogVisible: false,
      qrcodeUrl: '',
      orderNo: '',
      timer: null
    }
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },
  watch: {
    centerDialogVisible (newValue, oldValue) {
      if (newValue === true) {
        this.setTimer()
      } else {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    payConfirm () {
      var type = ''
      if (this.$data.payForm.payType === '微信') {
        type = 'WECHATPAY'
      } else if (this.$data.payForm.payType === '支付宝') {
        type = 'ALIPAY'
      } else {
        type = 'CUSTOMER'
      }
      var orderType = ''
      if (this.$data.payForm.months === '一天') {
        orderType = 'ONEDAY'
      } else if (this.$data.payForm.months === '一个月') {
        orderType = 'ONEMONTH'
      } else if (this.$data.payForm.months === '三个月') {
        orderType = 'THREEMONTH'
      } else if (this.$data.payForm.months === '一年') {
        orderType = 'ONEYEAR'
      }

      var postData = {payType: type, orderType: orderType}
      this.$axios.post('/pay/qrcode', this.$qs.stringify(postData)).then(res => {
        if (res.data['status'] === 200) {
          this.$data.centerDialogVisible = true
          this.$data.qrcodeUrl = res.data['data']['object']
          this.$data.orderNo = res.data['data']['orderNo']
        } else {
          this.$message.error('生成订单失败，请稍后再试')
        }
      }).catch(e => { this.$message.error('发起支付失败，请稍后再试') })
    },
    payFinish () {
      this.$axios.get('/pay/query?orderNo=' + this.$data.orderNo).then(res => {
        if (res.data['status'] === 200) {
          if (res.data['data'] === true) {
            this.$message({
              message: '订单已支付成功！',
              type: 'success'
            })
            this.$router.push({name: 'home'})
          } else {
            this.$message.info('订单还未支付成功，请支付后点击完成按钮！')
          }
        } else {
          this.$message.info('查询支付状态失败，请稍后再试')
        }
      }).catch(e => { this.$message.error('查询支付状态异常，请稍后再试') })
    },
    queryPayStatus () {
      this.$axios.get('/pay/query?orderNo=' + this.$data.orderNo).then(res => {
        if (res.data['status'] === 200) {
          if (res.data['data'] === true) {
            this.$message({
              message: '订单已支付成功！',
              type: 'success'
            })
            this.$router.push({name: 'home'})
          }
        }
      })
    },
    setTimer () {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.queryPayStatus()
        }, 2000)
      }
    }
  }
}
</script>

<style>
  .pay-container {
    flex-direction: column;
  }

  .pay-main {
    margin: auto;
    text-align: center;
    margin-top: 50px;
  }

  .sign {
    font-size: 15px;
    margin-right: 20px;
    font-weight: bold;
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/Pay.vue